import { ITheme } from 'src/types'
import { getActiveThemeSuccess } from '../themes/actions'
import { ThunkVoid } from '../types'
import { setDemoTheme } from './actions'

export const setDemoThemeThunk = (theme: ITheme): ThunkVoid => async dispatch => {
  dispatch(setDemoTheme(theme))
  dispatch(getActiveThemeSuccess({result: [theme]}))
}
